import { render, staticRenderFns } from "./KK_Statistics.vue?vue&type=template&id=6b55b06c&scoped=true&"
import script from "./KK_Statistics.vue?vue&type=script&lang=js&"
export * from "./KK_Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55b06c",
  null
  
)

export default component.exports